'use strict';

angular.module('cvsApp')
    .controller('AutomaticPaymentsCtrl', ["$scope", "$state", "userSession", "loggerService", "loggerServiceHelper", "webAnalytics",
        function ($scope, $state, UserSession, loggerService, loggerServiceHelper, webAnalytics) {
            if (UserSession.selectedPaymentMethod === undefined) {
                if (UserSession.accountData.activeMop !== undefined) {
                    UserSession.selectedPaymentMethod = UserSession.accountData.activeMop.paymentMethodId;
                }
            } else {
                var selectedPaymentMethodChanged = UserSession.accountData.paymentMethods.some(function(item) {
                    return item.paymentMethodId === UserSession.selectedPaymentMethod;
                });
                if (!selectedPaymentMethodChanged) {
                    UserSession.selectedPaymentMethod = UserSession.accountData.activeMop.paymentMethodId;
                }
            }
            
            var log = loggerService(loggerServiceHelper.setCategory(CVSLOGHELPER.CATEGORY.PAYMENT_REGISTERED) + loggerServiceHelper.setFlow("SetUpAutoPayment"));
            log.info(loggerServiceHelper.setAction(CVSLOGHELPER.ACTION.PAGE_LOAD) + loggerServiceHelper.setStep(CVSLOGHELPER.STEP.START));

            webAnalytics.webTrendsUtag("OBJ", {}, undefined, "autoPay");

            /*Scroll to top*/
            cvsUtility.genralPostMessage("SCROLL_TO", {
                "scroll": true
            });

            $scope.StillLoad = true;
            $scope.content = wcmContent;
            $scope.schedule = {};
            $scope.autoPaymentAmount = {
                valid: true,
                atLeastBalance: true,
                payImmediate: "true"
            };

            var todayDate = new Date();


            var _mop = UserSession.paymentMethod;
            $scope.accountDetails = UserSession.accountData.getMopById(_mop);
            $scope.autoPaylimit = $scope.accountDetails && $scope.accountDetails.payment && $scope.accountDetails.payment.amount ? "" + $scope.accountDetails.payment.amount : "" + angular.copy($scope.session.paymentAmount);;
            if (!$scope.autoPaylimit) {
                $scope.autoPaylimit = "";
            } else if ($scope.autoPaylimit && ($scope.autoPaylimit === "undefined" || $scope.autoPaylimit === "0")) {
                $scope.autoPaylimit = "";
            }
            $scope.getDays = _.range(1, 29);
            /* $scope.autoPayWithBalanceDate = function() {
               var date = moment().add(1, 'd').date();
               console.log("acccDetails issue", $scope.accountDetails.payment.frequency);
              if($scope.StillLoad && $scope.accountDetails && $scope.accountDetails.payment.frequency && ($scope.accountDetails.payment.frequency != "immediate" &&  $scope.accountDetails.payment.frequency != "Immediate" &&  $scope.accountDetails.payment.frequency != "IMMEDIATE")){
                 date= $scope.accountDetails.payment.frequency;
                 $scope.autoPaymentAmount.payImmediate="false";
               }
               return date;
             };*/

            $scope.onDateChange = function (date) {
                $scope.schedule = date;
            };
            //$scope.schedule= parseInt($scope.autoPayWithBalanceDate());


            $scope.validateAutoPaymentAmount = function (amt) {
                $scope.autoPaymentAmount.valid = true;
                $scope.autoPaymentAmount.atLeastBalance = true;
                if ($scope.minimumError(amt)) {
                    $scope.autoPaymentAmount.valid = false;
                    $scope.autoPaymentAmount.atLeastBalance = false;
                }

                return $scope.autoPaymentAmount.valid;
            };
            $scope.isBankAccount = function () {
                $scope.accountDetails.payment.type = "RECURRING";
                var _account = $scope.accountDetails;
                var _accountType;
                if (_account.payment.method == "CHECK") {
                    if ($scope.schedule) {
                        $scope.accountDetails.payment.frequency = $scope.schedule;
                    }
                    $scope.autoPaymentAmount.payImmediate = false;
                }
                if (_account) _accountType = _account.payment.method;
                return _accountType == "CHECK";
            };
            $scope.minimumError = function (amount) {
                // console.log(amount, amount < UserSession.accountData.currentBalance);
                return amount < UserSession.accountData.currentBalance;
            };

            $scope.disableFrequencyDate = function () {

                if (UserSession.accountData.currentBalance > 0) {
                    var td = moment().format("DD");
                    var isIncluded = _.includes(["28", "29", "30", "31"], td);
                    if (isIncluded) {
                        $scope.schedule = "1";
                        return "1";
                    } else {
                        $scope.schedule = moment().add(1, 'd').date();
                        return moment().add(1, 'd').date();
                    }
                } else if ($scope.accountDetails && $scope.accountDetails.payment && $scope.accountDetails.payment.method == "CCARD") {
                    $scope.schedule = 0;
                    UserSession.autoPay.schedule = 0;
                } else {
                    $scope.schedule = moment().add(1, 'd').date();;
                    UserSession.autoPay.schedule = moment().add(1, 'd').date();;
                }
                return false;
            };

            $scope.disableFrequencyDate();

            $scope.continue = function (autopayForm) {
                $scope.autoPaymentAmount.enterAmount = true;
                $scope.autoPaymentAmount.digitError = false;
                $scope.autoPaymentAmount.valid = true;
                $scope.autoPaymentAmount.atLeastBalance = true;
                $scope.autoPaymentAmount.invalid = false;
                $scope.autoPaymentDateError = false;
                var amt = angular.copy($scope.autoPaylimit);
                if (autopayForm.paymentDay && autopayForm.paymentDay.$modelValue !== "IMMEDIATE") {
                    if (new Date().getDate() === autopayForm.paymentDay.$modelValue) {
                        $scope.PAYMENT_STDATE_ERROR = true;
                        return;
                    }
                }
                if (!amt) {
                    $scope.autoPaymentAmount.enterAmount = false;
                    $scope.autoPaymentAmount.valid = false;
                    /*Scroll to top*/
                    cvsUtility.genralPostMessage("SCROLL_TO", {
                        "scroll": true
                    });
                    return;
                } else {
                    if (isNaN(amt)) {
                        $scope.autoPaymentAmount.valid = false;
                        $scope.autoPaymentAmount.invalid = true;
                        return;
                    } else
                    if (!cvsUtility.maxDecimalsDigit(2, "" + amt) || !cvsUtility.makeMaxDigits(8, amt)) {
                        $scope.autoPaymentAmount.digitError = true;
                        $scope.autoPaymentAmount.valid = false;
                        /*Scroll to top*/
                        cvsUtility.genralPostMessage("SCROLL_TO", {
                            "scroll": true
                        });
                        return;
                    }
                }
                if (!autopayForm.$valid) {
                    /*Scroll to top*/
                    cvsUtility.genralPostMessage("SCROLL_TO", {
                        "scroll": true
                    });
                    return;
                }

                var _valid = $scope.validateAutoPaymentAmount($scope.autoPaylimit);

                // If user has a balance, autopay schedule must be tomorrow
                if ($scope.autoPaymentAmount.payImmediate != "true") {
                    if (autopayForm.paymentDay.$modelValue) {
                        UserSession.autoPay.schedule = autopayForm.paymentDay.$modelValue;
                    } else {
                        $scope.autoPaymentAmount.valid = false;
                        $scope.autoPaymentDateError = true;
                        cvsUtility.genralPostMessage("SCROLL_TO", {
                            "scroll": true
                        });
                        return;
                    }

                } else {
                    // If chooses to pay immediate, set schedule to 0
                    if (!$scope.isBankAccount() && $scope.autoPaymentAmount.payImmediate && $scope.autoPaymentAmount.payImmediate == "true") {
                        UserSession.autoPay.schedule = 0;
                    }
                }

                //  Set payment amount
                if (_valid) {
                    $scope.accountDetails.payment.amount = autopayForm.autopayAmount.$modelValue;
                    if ($scope.disableFrequencyDate()) {
                        UserSession.autoPay.schedule = $scope.disableFrequencyDate();
                        $scope.accountDetails.payment.frequency = $scope.disableFrequencyDate();
                    } else {
                        $scope.accountDetails.payment.frequency = $scope.autoPaymentAmount.payImmediate && $scope.autoPaymentAmount.payImmediate == "true" ? "Immediate" : autopayForm.paymentDay.$modelValue;
                        if ($scope.accountDetails.payment.frequency && ("" + $scope.accountDetails.payment.frequency).toUpperCase() === "IMMEDIATE") {
                            UserSession.autoPay.schedule = 0;
                        } else {
                            UserSession.autoPay.schedule = angular.copy($scope.accountDetails.payment.frequency);
                        }
                    }

                    UserSession.paymentType = "auto";
                    log.debug(loggerServiceHelper.setAction(CVSLOGHELPER.ACTION.BUTTON_CLICK) + loggerServiceHelper.setStep("Agree&ContinueButton") + loggerServiceHelper.setDescription("Navigating to review payment page"));
                    UserSession.reviewPageAutoPay.limit = $scope.autoPaylimit;
                    log.debug(loggerServiceHelper.setAction(CVSLOGHELPER.ACTION.BUTTON_CLICK) + loggerServiceHelper.setStep(CVSLOGHELPER.STEP.END));
                    $state.go("review-payments");
                }
            };
            $scope.StillLoad = false;
            log.info(loggerServiceHelper.setAction(CVSLOGHELPER.ACTION.PAGE_LOAD) + loggerServiceHelper.setStep(CVSLOGHELPER.STEP.END) + loggerServiceHelper.setDescription("Set up Automatic payment page load completed"));
        }
    ]);